// extracted by mini-css-extract-plugin
module.exports = {"cartIconContainer":"cartIcon-module--cartIconContainer--1qUIi","itemCount":"cartIcon-module--itemCount--lgpFG"};